import { Dialog, DialogContent } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { EEA2Service } from '../../../../Component/Api/EmploymentEquity/WorkforceProfile_EEA2/EEA2Service';
import { MDBox } from '../../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';
import { WorkforceProfileDto } from '../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/WorkforceProfile';
import { Gender, MovementTypes, RaceTypes, UserActivityActionType } from '../../../../Component/Model/Enum/BEE123Enums';
import { EEOccupationalLevel } from '../../../../Component/Model/Enum/EmploymentEquity';
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle';
import { MovementsDrilldown } from './MovementsDrilldown';
import { toast } from 'react-toastify';
import { HeadcountSummaryTable } from '../../../../Component/Common/Components/Table/HeadcountSummaryTable';
import { SkeletonLoading } from '../../../../Component/Common/SkeletonLoading/SkeletonLoading';
import { UserActivityService } from '../../../../Component/Api/UserActivity/UserActivityService';
import { MovementsSection } from '../../../../Component/Common/Constants/UserActivityTrackingSections';

interface IProps {
    scorecardId: string;
}

export const Movements: FC<IProps> = (props) => {
    const [recruitmentData, setRecruitmentData] = React.useState<WorkforceProfileDto.SummarySectionDto[]>([]);
    const [promotionData, setPromotionData] = React.useState<WorkforceProfileDto.SummarySectionDto[]>([]);
    const [terminationData, setTerminationData] = React.useState<WorkforceProfileDto.SummarySectionDto[]>([]);
    const [showDrillDown, setShowDrillDown] = React.useState<boolean>(false);
    const [isPermanent, setIsPermanent] = React.useState<boolean | null>();
    const [eeOccupationId, setEEOccupationId] = React.useState<number>();
    const [raceId, setRaceId] = React.useState<number>();
    const [genderId, setGenderId] = React.useState<number>();
    const [movementType, setMovementType] = React.useState<MovementTypes>(MovementTypes.Recruitment);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const fetchData = async (scorecardId: string) => {
        setIsLoading(true);
        try {
            let searchResult = await EEA2Service.GetEmployeeMovementHeadcountSummary(scorecardId);
            setRecruitmentData(searchResult.data.recruitment);
            setPromotionData(searchResult.data.promotion);
            setTerminationData(searchResult.data.termination);
        } catch (error: any) {
            console.log(error);
            toast.error(error.response.data);           
        } finally {
            setIsLoading(false);
        }
    };

    const onRecruitmentClick = (occupationalLevel?: EEOccupationalLevel, race?: RaceTypes, gender?: Gender, isPermanent?: boolean) => {
        setMovementType(MovementTypes.Recruitment);
        setDrillDownValues(occupationalLevel, race, gender, isPermanent);
    }

    const onPromotionClick = (occupationalLevel?: EEOccupationalLevel, race?: RaceTypes, gender?: Gender, isPermanent?: boolean) => {
        setMovementType(MovementTypes.Promotion);
        setDrillDownValues(occupationalLevel, race, gender, isPermanent);
    }

    const onTerminationClick = (occupationalLevel?: EEOccupationalLevel, race?: RaceTypes, gender?: Gender, isPermanent?: boolean) => {
        setMovementType(MovementTypes.Termination);
        setDrillDownValues(occupationalLevel, race, gender, isPermanent);
    }

    const setDrillDownValues = (occupationalLevel?: EEOccupationalLevel, race?: RaceTypes, gender?: Gender, isPermanent?: boolean) => {
        setEEOccupationId(occupationalLevel);
        setRaceId(race);
        setGenderId(gender);
        setShowDrillDown(true);
        setIsPermanent(isPermanent);
    }

    useEffect(() => {
        fetchData(props.scorecardId);
        UserActivityService.createActivityLog({
            section: MovementsSection,
            actionType: UserActivityActionType.View,
            actionDescription: "View movements",
            scorecardId: props.scorecardId,
            requestUrl: window.location.href
        });
        return () => {}
    }, [props.scorecardId]);

    return (
        <>
            <MDBox>
                <MDBox mb={3} mt={3} style={{ backgroundColor: "white", padding: "15px", paddingTop:"10px"}}>
                    <MDTypography color="info" fontWeight="bold" style={{ paddingBottom: "15px" }}>
                        Recruitment
                    </MDTypography>
                    {
                        (!isLoading && recruitmentData.length > 0)
                        ? <HeadcountSummaryTable tableData={recruitmentData} onSegmentClick={onRecruitmentClick}/>
                        : <SkeletonLoading tableLoading/>
                    }
                </MDBox>
                <MDBox mb={3} style={{ backgroundColor: "white", padding: "15px", paddingTop:"10px" }}>
                    <MDTypography color="info" fontWeight="bold" style={{ paddingBottom: "15px" }}>
                        Promotion
                    </MDTypography>
                    {
                        (!isLoading && promotionData.length > 0)
                        ? <HeadcountSummaryTable tableData={promotionData} onSegmentClick={onPromotionClick}/>
                        : <SkeletonLoading tableLoading/>
                    }
                </MDBox>
                <MDBox mb={3} style={{ backgroundColor: "white", padding: "15px", paddingTop:"10px" }}>
                    <MDTypography color="info" fontWeight="bold" style={{ paddingBottom: "15px" }}>
                        Termination
                    </MDTypography>
                    {
                        (!isLoading && terminationData.length > 0)
                        ? <HeadcountSummaryTable tableData={terminationData} onSegmentClick={onTerminationClick}/>
                        : <SkeletonLoading tableLoading/>
                    }
                </MDBox>
            </MDBox>

            <Dialog open={showDrillDown} onClose={() => setShowDrillDown(false)} aria-labelledby="form-dialog-title" maxWidth={false} sx={{ minWidth: "1200px" }}>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => setShowDrillDown(false)}>
                    {"Employee Structure"}
                </CustomDialogTitle>
                <DialogContent>
                    <MovementsDrilldown scorecardId={props.scorecardId} eeOccupationId={eeOccupationId} raceId={raceId} genderId={genderId} isPermanent={isPermanent} movementType={movementType} />
                </DialogContent>
            </Dialog>
        </>
    )
}
